import { FC } from "react";
import type { ReactNode } from "react";
import { Checkbox } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import type { RateConditionsRenderProps } from "../RateConditions";

type RateConditionsContentProps = {
  checked?: boolean;
  conditionsList: ReactNode;
  onCheck: RateConditionsRenderProps["onCheck"];
  onClose: () => void;
  className?: string;
};

const RateConditionsContent: FC<RateConditionsContentProps> = ({ checked, conditionsList, onCheck, onClose, className }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames("flex flex-col gap-4 overflow-y-auto p-5", className)}>
      {conditionsList}
      <Checkbox checked={checked} onChange={(e) => onCheck(e, onClose)}>
        <span className="text-font-default text-base font-semibold">{t("Hotels.guests.policiesAcceptance")}</span>
      </Checkbox>
    </div>
  );
};

export default RateConditionsContent;
